import React, { useState } from 'react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardSidebar } from '../components/dashboard/DashboardSidebar';
import { BarChart2Icon, CalendarIcon, DownloadIcon, TrendingUpIcon, TrendingDownIcon, PieChartIcon, LineChartIcon, MapPinIcon, TagIcon, CheckIcon, ClipboardIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line, AreaChart, Area } from 'recharts';
export function StatisticsDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dateRange, setDateRange] = useState('month');
  // Mock user data
  const [userData] = useState({
    name: 'FATHALLAH Mehdi',
    company: 'Tunipages',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    email: 'mehdi.fathallah@tunipages.com'
  });
  // Mock statistics data
  const stats = [{
    id: 1,
    name: "Appels d'offres consultés",
    value: '254',
    change: '+12%',
    trend: 'up'
  }, {
    id: 2,
    name: 'Recherches effectuées',
    value: '78',
    change: '+8%',
    trend: 'up'
  }, {
    id: 3,
    name: 'Documents téléchargés',
    value: '35',
    change: '+15%',
    trend: 'up'
  }, {
    id: 4,
    name: "Appels d'offres favoris",
    value: '12',
    change: '-2%',
    trend: 'down'
  }];
  // Mock chart data
  const activityData = [{
    name: 'Lun',
    consultations: 12,
    recherches: 8,
    telechargements: 3
  }, {
    name: 'Mar',
    consultations: 19,
    recherches: 12,
    telechargements: 5
  }, {
    name: 'Mer',
    consultations: 15,
    recherches: 10,
    telechargements: 4
  }, {
    name: 'Jeu',
    consultations: 22,
    recherches: 15,
    telechargements: 7
  }, {
    name: 'Ven',
    consultations: 28,
    recherches: 20,
    telechargements: 9
  }, {
    name: 'Sam',
    consultations: 10,
    recherches: 5,
    telechargements: 2
  }, {
    name: 'Dim',
    consultations: 8,
    recherches: 4,
    telechargements: 1
  }];
  const sectorData = [{
    name: 'IT & Télécoms',
    value: 35
  }, {
    name: 'BTP & Construction',
    value: 25
  }, {
    name: 'Énergie & Utilities',
    value: 15
  }, {
    name: 'Santé',
    value: 10
  }, {
    name: 'Transport & Logistique',
    value: 8
  }, {
    name: 'Autres',
    value: 7
  }];
  const locationData = [{
    name: 'Tunis',
    value: 42
  }, {
    name: 'Sfax',
    value: 18
  }, {
    name: 'Sousse',
    value: 15
  }, {
    name: 'Bizerte',
    value: 8
  }, {
    name: 'Monastir',
    value: 7
  }, {
    name: 'Autres',
    value: 10
  }];
  const monthlyTrendsData = [{
    name: 'Jan',
    consultations: 120,
    opportunites: 10
  }, {
    name: 'Fév',
    consultations: 145,
    opportunites: 12
  }, {
    name: 'Mar',
    consultations: 160,
    opportunites: 15
  }, {
    name: 'Avr',
    consultations: 190,
    opportunites: 18
  }, {
    name: 'Mai',
    consultations: 210,
    opportunites: 22
  }, {
    name: 'Juin',
    consultations: 220,
    opportunites: 25
  }];
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];
  // Handle date range change
  const handleDateRangeChange = (range: string) => {
    setDateRange(range);
    // Here you would typically fetch new data based on the selected range
    console.log(`Date range changed to: ${range}`);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-3768">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-3769" />}
      {/* Sidebar */}
      <DashboardSidebar open={sidebarOpen} setOpen={setSidebarOpen} data-id="element-3770" />
      {/* Main content */}
      <div className="md:pl-64" data-id="element-3771">
        {/* Header */}
        <DashboardHeader user={userData} onMenuClick={() => setSidebarOpen(true)} data-id="element-3772" />
        {/* Main content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8" data-id="element-3773">
          {/* Page header */}
          <div className="mb-6" data-id="element-3774">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-3775">
              <div className="flex items-center mb-4 sm:mb-0" data-id="element-3776">
                <BarChart2Icon size={24} className="text-blue-600 mr-3" data-id="element-3777" />
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-3778">
                  Statistiques
                </h1>
              </div>
              <div className="flex items-center space-x-3" data-id="element-3779">
                <div className="bg-white rounded-md shadow-sm border border-gray-200 flex" data-id="element-3780">
                  <button className={`px-4 py-2 text-sm font-medium ${dateRange === 'week' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-50'} rounded-l-md`} onClick={() => handleDateRangeChange('week')} data-id="element-3781">
                    Semaine
                  </button>
                  <button className={`px-4 py-2 text-sm font-medium ${dateRange === 'month' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-50'}`} onClick={() => handleDateRangeChange('month')} data-id="element-3782">
                    Mois
                  </button>
                  <button className={`px-4 py-2 text-sm font-medium ${dateRange === 'year' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-50'} rounded-r-md`} onClick={() => handleDateRangeChange('year')} data-id="element-3783">
                    Année
                  </button>
                </div>
                <Button variant="outline" className="flex items-center" data-id="element-3784">
                  <DownloadIcon size={16} className="mr-2" data-id="element-3785" />
                  Exporter
                </Button>
                <Button variant="outline" className="flex items-center" data-id="element-3786">
                  <div size={16} className="mr-2" data-id="element-3787" />
                  Actualiser
                </Button>
              </div>
            </div>
            <p className="text-gray-600 mt-2" data-id="element-3788">
              Analysez votre activité et suivez les tendances des appels
              d'offres
            </p>
          </div>
          {/* Stats overview */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-3789">
            {stats.map(stat => <div key={stat.id} className="bg-white rounded-lg shadow-md p-6 border border-gray-100" data-id="element-3790">
                <div className="flex items-center justify-between mb-4" data-id="element-3791">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-3792">
                    {stat.name}
                  </h3>
                  {stat.trend === 'up' ? <TrendingUpIcon size={18} className="text-green-500" data-id="element-3793" /> : <TrendingDownIcon size={18} className="text-red-500" data-id="element-3794" />}
                </div>
                <div className="flex items-baseline" data-id="element-3795">
                  <p className="text-3xl font-bold text-gray-900" data-id="element-3796">
                    {stat.value}
                  </p>
                  <p className={`ml-2 text-sm font-medium ${stat.trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-3797">
                    {stat.change}
                  </p>
                </div>
                <div className="mt-1 text-xs text-gray-500" data-id="element-3798">
                  Par rapport au mois dernier
                </div>
              </div>)}
          </div>
          {/* Activity chart */}
          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100 mb-8" data-id="element-3799">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6" data-id="element-3800">
              <div data-id="element-3801">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-3802">
                  Activité récente
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-3803">
                  Suivi de votre activité sur les 7 derniers jours
                </p>
              </div>
              <div className="mt-3 sm:mt-0" data-id="element-3804">
                <Button variant="outline" size="sm" className="text-xs" data-id="element-3805">
                  <ClipboardIcon size={14} className="mr-1" data-id="element-3806" />
                  Rapport détaillé
                </Button>
              </div>
            </div>
            <div className="h-80" data-id="element-3807">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3808">
                <BarChart data={activityData} margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5
              }} data-id="element-3809">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-3810" />
                  <XAxis dataKey="name" data-id="element-3811" />
                  <YAxis data-id="element-3812" />
                  <Tooltip data-id="element-3813" />
                  <Legend data-id="element-3814" />
                  <Bar dataKey="consultations" name="Consultations" fill="#3B82F6" data-id="element-3815" />
                  <Bar dataKey="recherches" name="Recherches" fill="#10B981" data-id="element-3816" />
                  <Bar dataKey="telechargements" name="Téléchargements" fill="#F59E0B" data-id="element-3817" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          {/* Charts row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-3818">
            {/* Sectors chart */}
            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100" data-id="element-3819">
              <div className="flex items-center mb-6" data-id="element-3820">
                <PieChartIcon size={20} className="text-blue-600 mr-2" data-id="element-3821" />
                <h2 className="text-lg font-medium text-gray-900" data-id="element-3822">
                  Répartition par secteur
                </h2>
              </div>
              <div className="h-64" data-id="element-3823">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3824">
                  <PieChart data-id="element-3825">
                    <Pie data={sectorData} cx="50%" cy="50%" labelLine={false} label={({
                    name,
                    percent
                  }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-3826">
                      {sectorData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-3827" />)}
                    </Pie>
                    <Tooltip formatter={(value, name) => [`${value}%`, name]} data-id="element-3828" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-3829">
                {sectorData.map((item, index) => <div key={index} className="flex items-center" data-id="element-3830">
                    <div className="w-3 h-3 rounded-full mr-2" style={{
                  backgroundColor: COLORS[index % COLORS.length]
                }} data-id="element-3831"></div>
                    <span className="text-xs text-gray-600" data-id="element-3832">{item.name}</span>
                  </div>)}
              </div>
            </div>
            {/* Locations chart */}
            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100" data-id="element-3833">
              <div className="flex items-center mb-6" data-id="element-3834">
                <MapPinIcon size={20} className="text-blue-600 mr-2" data-id="element-3835" />
                <h2 className="text-lg font-medium text-gray-900" data-id="element-3836">
                  Répartition géographique
                </h2>
              </div>
              <div className="h-64" data-id="element-3837">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3838">
                  <PieChart data-id="element-3839">
                    <Pie data={locationData} cx="50%" cy="50%" labelLine={false} label={({
                    name,
                    percent
                  }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-3840">
                      {locationData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-3841" />)}
                    </Pie>
                    <Tooltip formatter={(value, name) => [`${value}%`, name]} data-id="element-3842" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-3843">
                {locationData.map((item, index) => <div key={index} className="flex items-center" data-id="element-3844">
                    <div className="w-3 h-3 rounded-full mr-2" style={{
                  backgroundColor: COLORS[index % COLORS.length]
                }} data-id="element-3845"></div>
                    <span className="text-xs text-gray-600" data-id="element-3846">{item.name}</span>
                  </div>)}
              </div>
            </div>
          </div>
          {/* Monthly trends */}
          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100 mb-8" data-id="element-3847">
            <div className="flex items-center mb-6" data-id="element-3848">
              <LineChartIcon size={20} className="text-blue-600 mr-2" data-id="element-3849" />
              <h2 className="text-lg font-medium text-gray-900" data-id="element-3850">
                Tendances mensuelles
              </h2>
            </div>
            <div className="h-80" data-id="element-3851">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3852">
                <AreaChart data={monthlyTrendsData} margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5
              }} data-id="element-3853">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-3854" />
                  <XAxis dataKey="name" data-id="element-3855" />
                  <YAxis data-id="element-3856" />
                  <Tooltip data-id="element-3857" />
                  <Legend data-id="element-3858" />
                  <Area type="monotone" dataKey="consultations" name="Consultations" stroke="#3B82F6" fill="#3B82F6" fillOpacity={0.2} data-id="element-3859" />
                  <Area type="monotone" dataKey="opportunites" name="Opportunités" stroke="#F59E0B" fill="#F59E0B" fillOpacity={0.2} data-id="element-3860" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
          {/* Performance metrics */}
          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100" data-id="element-3861">
            <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-3862">
              Indicateurs de performance
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3863">
              <div data-id="element-3864">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-3865">
                  Taux de consultation
                </h3>
                <div className="flex items-center" data-id="element-3866">
                  <div className="text-2xl font-bold text-gray-900 mr-2" data-id="element-3867">
                    68%
                  </div>
                  <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full flex items-center" data-id="element-3868">
                    <TrendingUpIcon size={12} className="mr-1" data-id="element-3869" />
                    +5%
                  </div>
                </div>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5" data-id="element-3870">
                  <div className="bg-blue-600 h-1.5 rounded-full" style={{
                  width: '68%'
                }} data-id="element-3871"></div>
                </div>
              </div>
              <div data-id="element-3872">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-3873">
                  Taux de conversion
                </h3>
                <div className="flex items-center" data-id="element-3874">
                  <div className="text-2xl font-bold text-gray-900 mr-2" data-id="element-3875">
                    12%
                  </div>
                  <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full flex items-center" data-id="element-3876">
                    <TrendingUpIcon size={12} className="mr-1" data-id="element-3877" />
                    +2%
                  </div>
                </div>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5" data-id="element-3878">
                  <div className="bg-green-600 h-1.5 rounded-full" style={{
                  width: '12%'
                }} data-id="element-3879"></div>
                </div>
              </div>
              <div data-id="element-3880">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-3881">
                  Taux d'engagement
                </h3>
                <div className="flex items-center" data-id="element-3882">
                  <div className="text-2xl font-bold text-gray-900 mr-2" data-id="element-3883">
                    45%
                  </div>
                  <div className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full flex items-center" data-id="element-3884">
                    <TrendingDownIcon size={12} className="mr-1" data-id="element-3885" />
                    -3%
                  </div>
                </div>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5" data-id="element-3886">
                  <div className="bg-yellow-500 h-1.5 rounded-full" style={{
                  width: '45%'
                }} data-id="element-3887"></div>
                </div>
              </div>
              <div data-id="element-3888">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-3889">
                  Temps moyen par session
                </h3>
                <div className="flex items-center" data-id="element-3890">
                  <div className="text-2xl font-bold text-gray-900 mr-2" data-id="element-3891">
                    8m 35s
                  </div>
                  <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full flex items-center" data-id="element-3892">
                    <TrendingUpIcon size={12} className="mr-1" data-id="element-3893" />
                    +15%
                  </div>
                </div>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5" data-id="element-3894">
                  <div className="bg-purple-600 h-1.5 rounded-full" style={{
                  width: '75%'
                }} data-id="element-3895"></div>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-3896">
              <h3 className="text-sm font-medium text-gray-900 mb-4" data-id="element-3897">
                Récapitulatif des objectifs
              </h3>
              <div className="space-y-4" data-id="element-3898">
                <div data-id="element-3899">
                  <div className="flex items-center justify-between mb-1" data-id="element-3900">
                    <div className="flex items-center" data-id="element-3901">
                      <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-3902" />
                      <span className="text-sm text-gray-700" data-id="element-3903">
                        Consultations mensuelles
                      </span>
                    </div>
                    <span className="text-sm font-medium text-gray-900" data-id="element-3904">
                      210/200
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-3905">
                    <div className="bg-green-500 h-1.5 rounded-full" style={{
                    width: '105%'
                  }} data-id="element-3906"></div>
                  </div>
                </div>
                <div data-id="element-3907">
                  <div className="flex items-center justify-between mb-1" data-id="element-3908">
                    <div className="flex items-center" data-id="element-3909">
                      <CheckIcon size={16} className="text-green-500 mr-2" data-id="element-3910" />
                      <span className="text-sm text-gray-700" data-id="element-3911">
                        Téléchargements
                      </span>
                    </div>
                    <span className="text-sm font-medium text-gray-900" data-id="element-3912">
                      35/30
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-3913">
                    <div className="bg-green-500 h-1.5 rounded-full" style={{
                    width: '116%'
                  }} data-id="element-3914"></div>
                  </div>
                </div>
                <div data-id="element-3915">
                  <div className="flex items-center justify-between mb-1" data-id="element-3916">
                    <div className="flex items-center" data-id="element-3917">
                      <TagIcon size={16} className="text-yellow-500 mr-2" data-id="element-3918" />
                      <span className="text-sm text-gray-700" data-id="element-3919">
                        Opportunités identifiées
                      </span>
                    </div>
                    <span className="text-sm font-medium text-gray-900" data-id="element-3920">
                      18/25
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-3921">
                    <div className="bg-yellow-500 h-1.5 rounded-full" style={{
                    width: '72%'
                  }} data-id="element-3922"></div>
                  </div>
                </div>
                <div data-id="element-3923">
                  <div className="flex items-center justify-between mb-1" data-id="element-3924">
                    <div className="flex items-center" data-id="element-3925">
                      <TagIcon size={16} className="text-red-500 mr-2" data-id="element-3926" />
                      <span className="text-sm text-gray-700" data-id="element-3927">
                        Réponses soumises
                      </span>
                    </div>
                    <span className="text-sm font-medium text-gray-900" data-id="element-3928">
                      5/10
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-3929">
                    <div className="bg-red-500 h-1.5 rounded-full" style={{
                    width: '50%'
                  }} data-id="element-3930"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
}